import React from 'react';
import fetchTree, { group, depends, preload, loader } from 'fetch-tree';
import { allTermsLoader } from '../resources/terms';
import { swEnabled } from '../engage_cache.js';
import { setReadyStatus } from '../actions/offline';
import { selectOfflineContentIds } from '../selectors/offline';
import { selectUser } from '../selectors/current_user';

import { resources as allNotesResources } from './all_notes.jsx';

// If service workers aren't enabled this is a simple component that doesn't do anything.
let OfflineSetup;

OfflineSetup = function NOOP() {
    return <noscript />;
};

const OfflineLoader = fetchTree({
    component: OfflineSetup,

    resources: group({
        allTerms: allTermsLoader,
        offlineContentIds: selectOfflineContentIds,
        user: selectUser,
        allNotes: depends(
            ['user.v3_uri', 'offlineContentIds'],
            preload((useProps, current_user_uri, ids) =>
                ids.map(id =>
                    useProps(
                        {
                            params: {
                                contentId: id,
                            },
                            query: '',
                            current_user_uri,
                            controlPanelIsOpen: false,
                        },
                        allNotesResources
                    )
                )
            )
        ),
        offlineStatus: depends(
            ['allNotes'],
            loader({
                id: () => 'offline-status',
                // This isn't really an async action, so a promise needs
                // to be created here.
                action: () => dispatch =>
                    Promise.resolve(dispatch(setReadyStatus())),
                selector: () => true,
            })
        ),
    }),
});

if (swEnabled) {
    OfflineSetup = OfflineLoader;
}

export default OfflineSetup;



// WEBPACK FOOTER //
// ./src/components/offline_setup.jsx